var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex flex-col w-full sm:items-center sm:justify-center"},[_c('p',{staticClass:"font-thin opacity-70  leading-tight my-2",class:[
      'xl:text-base xl:w-3/4 xl:text-center',
      'text-sm text-center'
    ]},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }